import React from "react"
import {
  Alert as GluestackAlert,
  AlertIcon as GluestackAlertIcon,
  AlertText as GluestackAlertText,
} from "./gluestack/alert"

export interface AlertProps {
  children?: React.ReactNode
  className?: string
  action?: "error" | "warning" | "success" | "info" | "muted"
  variant?: "solid" | "outline"
}

export interface AlertTextProps {
  children?: React.ReactNode
  className?: string
  size?: "xs" | "sm" | "md" | "lg"
  bold?: boolean
}

export interface AlertIconProps {
  className?: string
  size?: "xs" | "sm" | "md" | "lg"
}

export const Alert = ({
  children,
  className,
  action = "muted",
  variant = "solid",
  ...props
}: AlertProps & any) => {
  return (
    <GluestackAlert
      className={className}
      action={action}
      variant={variant}
      {...props}
    >
      {children}
    </GluestackAlert>
  )
}

export const AlertText = ({
  children,
  className,
  size = "md",
  bold = false,
  ...props
}: AlertTextProps & any) => {
  return (
    <GluestackAlertText
      className={className}
      size={size}
      bold={bold}
      {...props}
    >
      {children}
    </GluestackAlertText>
  )
}

export const AlertIcon = ({
  className,
  size = "md",
  ...props
}: AlertIconProps & any) => {
  return <GluestackAlertIcon className={className} size={size} {...props} />
}
